<template>
  <div>Edit Fun</div>
</template>

<script>
export default {};
</script>